import { useGetCurrentUser } from '@/modules/Users/queries';
import { useContext } from 'react';
import { Modal } from '../Modal';
import { OrganizationContext } from '../OrganizationProvider/OrganizationProvider';
import { Spinner } from '../Spinner';
import OrganizationPicker from './OrganizationPicker';

type OrganizationPickerModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export default function OrganizationPickerModal({
  isOpen,
  onClose,
}: OrganizationPickerModalProps) {
  const { data: user, isLoading } = useGetCurrentUser();
  const { setOrganizationId } = useContext(OrganizationContext);
  const selectedOrganizationId = +(
    sessionStorage.getItem('organizationId') ?? 0
  );
  return (
    <Modal
      modalClassName="w-min"
      isOpen={isOpen}
      handleClose={onClose}
      allowClickOutsideToClose
      hideCloseButton
    >
      {isLoading ? (
        <Spinner />
      ) : (
        <OrganizationPicker
          organizations={user?.organizations ?? []}
          onSelect={(id) => {
            setOrganizationId(id);
            onClose();
          }}
          className="p-0"
          selectedId={selectedOrganizationId}
        />
      )}
    </Modal>
  );
}
